import { Grid, IconButton, Paper, Stack, Typography, Box } from "@mui/material";
import { CardProps, CotacaoRealizada } from "..";
import TimeLineStepper from "../../../../../../../components/BasicComponents/DisplayDados/TimeLineStepper";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { formatarValorMonetario } from "../../../../../../../helpers/masks";
import { TableSimples } from "../../../../../../../components/BasicComponents/DisplayDados/TableSimples";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import moment from "moment";
import { useState } from "react";
import DialogDetalharCotacao from "./DialogDetalharCotacao";
import { enqueueSnackbar } from "notistack";


export default function CardCotacoesRealizadas({ data }: CardCotacoesRealizadasProps) {

    const [openDetalhar, setOpenDetalhar] = useState<CotacaoRealizada | null>(null);

    const handleCopiarUrl = async (url: string | null) => {
        try {
            await navigator.clipboard.writeText(url || "");
            enqueueSnackbar("Link copiado para a área de transferência!", { variant: "success" });
        } catch (error) {
            console.error('Erro ao copiar URL:', error);
            enqueueSnackbar("Erro ao copiar link", { variant: "error" });
        }
    };

    return (
        <Paper sx={{ p: 2 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
                Cotações realizadas
            </Typography>
            {
                data.cotacoes.length === 0 &&
                <Typography variant="body2" color="text.secondary">
                    Nenhuma cotação realizada
                </Typography>
            }
            {
                data.cotacoes.length > 0 &&
                <TimeLineStepper
                    Icon={CheckCircleIcon}
                    dinamicIcon={(index) => {
                        const item = data.cotacoes[index];
                        if (!item.respondido_em) {
                            return QueryBuilderIcon;
                        }
                        return CheckCircleIcon;
                    }}
                    dinamicIconProps={(index) => {
                        const item = data.cotacoes[index];
                        if (!item.respondido_em) {
                            return {
                                fontSize: "medium",
                                color: "warning",
                                sx: { display: "flex", alignItems: "center", justifyContent: "center" }
                            };
                        }
                        return {
                            fontSize: "medium",
                            color: "primary",
                            sx: { display: "flex", alignItems: "center", justifyContent: "center" }
                        };
                    }}
                    Itens={data.cotacoes.map((item) => {
                        return {
                            itensLabel: (
                                <>
                                    {
                                        item.itens.some(i => i.usuario_alteracao) && (
                                            <Box sx={{
                                                mb: 1,
                                                p: 1,
                                                bgcolor: 'info.light',
                                                borderRadius: 1,
                                                border: '1px solid',
                                                borderColor: 'info.main'
                                            }}>
                                                <Typography variant="caption" color="info.contrastText" sx={{ fontWeight: 500 }}>
                                                    Quantidade alterada:
                                                </Typography>
                                                {item.itens
                                                    .filter(i => i.usuario_alteracao)
                                                    .map((itemAlterado, index) => (
                                                        <Typography
                                                            key={index}
                                                            variant="caption"
                                                            color="info.contrastText"
                                                            sx={{ display: 'block', ml: 1 }}
                                                        >
                                                            • {itemAlterado.produto_nome} foi alterado por {itemAlterado.usuario_alteracao} em {moment(itemAlterado.criado_em).format('DD/MM/YYYY HH:mm')}
                                                        </Typography>
                                                    ))
                                                }
                                            </Box>
                                        )
                                    }
                                    <Stack direction={'row'} spacing={2} alignItems={'center'} justifyContent={'space-between'} width={'100%'}>
                                        {
                                            !item.respondido_em &&

                                            <Stack direction={'column'} width={'100%'}>
                                                <Typography variant="body1" color="textSecondary">
                                                    Solicitação aguardando resposta do fornecedor
                                                </Typography>

                                                <Typography variant="body1" color="textSecondary">
                                                    Vencimento: {moment(item.vencimento).format('DD/MM/YYYY')} | Fornecedor: {item.fornecedor}
                                                </Typography>

                                                <Box
                                                    onClick={() => handleCopiarUrl(item.url_formulario)}
                                                    sx={{
                                                        mt: 1,
                                                        maxWidth: '300px',
                                                        backgroundColor: 'grey.100',
                                                        border: '1px solid',
                                                        borderColor: 'grey.300',
                                                        borderRadius: '4px',
                                                        padding: '4px 8px',
                                                        cursor: 'pointer',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'space-between',
                                                        '&:hover': {
                                                            backgroundColor: 'grey.200',
                                                        }
                                                    }}
                                                >
                                                    <Typography
                                                        variant="caption"
                                                        color="textSecondary"
                                                        sx={{
                                                            flex: 1,
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            whiteSpace: 'nowrap',
                                                            fontSize: '0.75rem',
                                                            mr: 1
                                                        }}
                                                    >
                                                        {item.url_formulario || 'Link não disponível'}
                                                    </Typography>
                                                    <ContentCopyIcon
                                                        sx={{
                                                            fontSize: '0.875rem',
                                                            color: 'text.secondary',
                                                            flexShrink: 0
                                                        }}
                                                    />
                                                </Box>
                                            </Stack>
                                        }
                                        {
                                            item.respondido_em &&
                                            <Stack direction={'column'} width={'100%'}>
                                                <Stack direction={'row'} justifyContent={'space-between'} alignItems="center">
                                                    <Typography variant="body1" color="textSecondary">
                                                        Código: {item.id} - {item.criada_em} por {item.criada_por}
                                                    </Typography>
                                                    <IconButton
                                                        aria-label="editar"
                                                        color="primary"
                                                        onClick={() => setOpenDetalhar(item)}
                                                        title="Detalhar"
                                                    >
                                                        <VisibilityOutlinedIcon />
                                                    </IconButton>
                                                </Stack>

                                                <Grid container spacing={0.2} alignItems="center">
                                                    <Grid size={{ xs: 6 }}>
                                                        <Typography variant="caption" color="textSecondary">
                                                            {item.fornecedor_id} - {item.fornecedor}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={{ xs: 6 }}>
                                                        <Typography variant="caption" color="textSecondary">
                                                            Respondida em: {moment(item.respondido_em).format('DD/MM/YYYY HH:mm')}
                                                        </Typography>
                                                    </Grid>
                                                    {item.valor_frete && (
                                                        <Grid size={{ xs: 6 }}>
                                                            <Typography variant="caption" color="textSecondary">
                                                                Frete {formatarValorMonetario(Number(item.valor_frete) || 0)}
                                                            </Typography>
                                                        </Grid>
                                                    )}
                                                    {item.prazo_entrega !== null && (
                                                        <Grid size={{ xs: 6 }}>
                                                            <Typography variant="caption" color="textSecondary">
                                                                Previsão entrega {(item.prazo_entrega ?? 0)} DIAS
                                                            </Typography>
                                                        </Grid>
                                                    )}
                                                </Grid>
                                            </Stack>
                                        }
                                    </Stack>
                                </>
                            ),
                            itensContent: (
                                <>
                                    <TableSimples
                                        headers={[
                                            { label: "Produto" },
                                            { label: "Quantidade" },
                                            { label: "Valor Unitário", numeric: true },
                                            { label: "Valor Total", numeric: true },
                                        ]}
                                        rows={item.itens.map(row => {
                                            const temValorUnitario = row.valor_unitario && row.valor_unitario > 0;
                                            const temValorTotal = row.valor_total && Number(row.valor_total) > 0;

                                            return {
                                                columns: [
                                                    { value: row.produto_nome },
                                                    { value: `${row.quantidade} ${row.unidade_medida}` },
                                                    { value: temValorUnitario ? formatarValorMonetario(row.valor_unitario) : '-', numeric: true },
                                                    { value: temValorTotal ? formatarValorMonetario(Number(row.valor_total)) : '-', numeric: true },
                                                ]
                                            };
                                        })}
                                        total={{
                                            label: "Total",
                                            value: (() => {
                                                const temValores = item.itens.some(row => row.valor_total && Number(row.valor_total) > 0);
                                                if (temValores) {
                                                    return formatarValorMonetario(
                                                        item.itens.reduce((total, row) =>
                                                            total + Number(row.valor_total || 0), 0
                                                        )
                                                    );
                                                }
                                                return '-';
                                            })()
                                        }}
                                    />
                                </>
                            )
                        }
                    })}
                />
            }
            {
                openDetalhar && (
                    <DialogDetalharCotacao
                        open={Boolean(openDetalhar)}
                        onClose={() => setOpenDetalhar(null)}
                        cotacao={openDetalhar}
                    />
                )
            }
        </Paper>
    )
}

interface CardCotacoesRealizadasProps extends CardProps {

} 
